import { withConfiguration } from "./config";

const fetcher = (root, verb) => (path, payload, headers) => {
  return fetch(`${root}${path}`, {
    method: verb,
    headers: new Headers({
      "Content-Type": "application/json;charset=UTF-8",
      ...headers,
    }),
    body: payload !== undefined ? JSON.stringify(payload) : undefined,
  })
    .then((response) => response.json())
    .catch((err) => ({ error: err.message }));
};

export const post = withConfiguration((config) => {
  return fetcher(config["ESF_API"], "POST");
});

export const postClubMed = withConfiguration((config) => {
  return fetcher(config["CM_ROOT"], "POST");
});

export const getClubMed = withConfiguration((config) => {
  return fetcher(config["CM_ROOT"], "GET");
});



// WEBPACK FOOTER //
// ./src/services/fetcher.js